module.exports = __webpack_public_path__ + "img/9b31b49.jpg";